var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "admin-content-area",
      attrs: { id: "page-content-wrapper" }
    },
    [
      _c("div", { staticClass: "container-fluid xyz" }, [
        _c("div", { staticClass: "page-header-top-container" }, [
          _c("div", { staticClass: "page-name" }, [
            _vm._v(_vm._s(_vm.page_header))
          ]),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn-primary waves-effect pull-right",
              attrs: { type: "submit" },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.returnOnListing()
                }
              }
            },
            [_vm._v("Back")]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "admin-page-content" }, [
          _c("div", { staticClass: "forms-container" }, [
            _c("div", { staticClass: "row no-margin" }, [
              _c("div", { staticClass: "col-6 forms-block" }, [
                _vm._m(0),
                _vm._v(" "),
                _c("div", { staticClass: "col-9 paddingleft0" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.fields.name,
                        expression: "fields.name"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: { id: "name", type: "text" },
                    domProps: { value: _vm.fields.name },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.fields, "name", $event.target.value)
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "requiredstar" }, [_vm._v("*")]),
                  _vm._v(" "),
                  _c("span", { staticClass: "help is-danger" }, [
                    _vm._v(_vm._s(_vm.name_error_msg))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-6 forms-block" }, [
                _vm._m(1),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-9 paddingleft0" },
                  [
                    _c("v-select", {
                      attrs: {
                        name: "locationId",
                        id: "locationId",
                        label: "name",
                        filterable: true,
                        options: _vm.locationOption,
                        placeholder: "Select Location"
                      },
                      on: {
                        input: function($event) {
                          return _vm.onChnageLocation()
                        }
                      },
                      model: {
                        value: _vm.fields.locationId,
                        callback: function($$v) {
                          _vm.$set(_vm.fields, "locationId", $$v)
                        },
                        expression: "fields.locationId"
                      }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "requiredstar" }, [_vm._v("*")]),
                    _vm._v(" "),
                    _c("span", { staticClass: "text-danger" }, [
                      _vm._v(_vm._s(_vm.location_error_msg))
                    ])
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-6 forms-block" }, [
                _vm._m(2),
                _vm._v(" "),
                _c("div", { staticClass: "col-9 paddingleft0" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.fields.threshold_qty,
                        expression: "fields.threshold_qty"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: { id: "threshold_qty", type: "text" },
                    domProps: { value: _vm.fields.threshold_qty },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.fields,
                          "threshold_qty",
                          $event.target.value
                        )
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "requiredstar" }, [_vm._v("*")]),
                  _vm._v(" "),
                  _c("span", { staticClass: "help is-danger" }, [
                    _vm._v(_vm._s(_vm.threshold_qty_error_msg))
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "clearfix" }),
            _vm._v(" "),
            _c("div", { staticClass: "row clearfix" }),
            _vm._v(" "),
            _c("div", { staticClass: "button-demo" }, [
              _vm.$route.params.id > 0
                ? _c("input", {
                    staticClass: "btn btn-primary my-1 ms-2",
                    attrs: {
                      id: "addBenifitBtn",
                      disabled: _vm.disableButtons.save,
                      type: "submit"
                    },
                    domProps: { value: _vm.buttonNames.saveButton },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.updateRecord()
                      }
                    }
                  })
                : _c("input", {
                    staticClass: "btn btn-primary my-1 ms-2",
                    attrs: {
                      id: "addBenifitBtn",
                      disabled: _vm.disableButtons.save,
                      type: "submit"
                    },
                    domProps: { value: _vm.buttonNames.saveButton },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.createRecord()
                      }
                    }
                  }),
              _vm._v(" "),
              _c("input", {
                staticClass: "btn btn-primary my-1 ms-2",
                attrs: {
                  id: "CancelBenifit",
                  disabled: _vm.disableButtons.cancel,
                  type: "submit"
                },
                domProps: { value: _vm.buttonNames.cancel },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.returnOnListing.apply(null, arguments)
                  }
                }
              })
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("app-footer")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label" }, [_vm._v("Name :")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label" }, [_vm._v("Location :")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label" }, [_vm._v("Threshold qty :")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5d6e75d6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d6e75d6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Inventory/AddUpdateInventory.vue
// module id = null
// module chunks = 